import { render, staticRenderFns } from "./ShowScratchCard.vue?vue&type=template&id=4a5e7932&"
import script from "./ShowScratchCard.vue?vue&type=script&lang=js&"
export * from "./ShowScratchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports